.header {
    display: flex;
    align-items: center;
}

.image {
    width: 60px;
    padding-right: 12px;
}

.intro {
    color: var(--grey-dk);
    font-size: var(--font-normal);
    line-height: 20px;
    font-weight: 500;
}

.fact-top {
    display: flex;
    align-items: center;
    margin-bottom: 2px;
}

.star {
    color: var(--blue);
    padding-right: 4px;
}

.fun {
    font-weight: 500;
    color: var(--grey-dk);
}

.fact {
    padding: 12px;
    background-color: var(--blue-lt);
    border-radius: 3px;
}
